import axios from "axios";
import { getStore } from "../utils/localStorageUtil";
import { getInfo } from "../utils/urlUtil";

const isMockEnabled = import.meta.env.VITE_USE_MOCK === "false" ? false : true;

// if (isMockEnabled) {
//   console.log("Using mock data for all requests"); // Mensaje centralizado
// }

// Create an Axios instance with the base URL from environment variables
const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL, // Use baseURL from environment
  timeout: 10000, // Request timeout
  headers: { "Content-Type": "application/json" },
});

// Request interceptor to add the region header
api.interceptors.request.use(
  async (config) => {
    const urlInfo = typeof window !== "undefined" ? getInfo() : null;
    const localStore = getStore();
    const country = urlInfo?.isoCountry || localStore?.isoCountry || 'gl';
    const env = urlInfo?.env || localStore?.env || 'prod';
    const lang = localStore?.lang || 'eng';

    config.headers["isocountry"] = country; // Agrega la región al header
    config.headers["env"] = env; // Agrega el ambiente al header

    if (lang) {
      config.headers['lang'] = lang;
    }
    return config; // Retorna la configuración modificada
  },
  (error) => {
    return Promise.reject(error); // Maneja errores al configurar la solicitud
  }
);

// Response interceptor to handle centralized error handling
api.interceptors.response.use(
  (response) => response, // Return the response if it's successful
  (error) => {
    // Check if the error has a response from the server
    if (error.response) {
      const { status } = error.response;

      // Handle different error codes
      switch (status) {
        case 403:
          console.error("Access denied. You do not have permission for this action.");
          break;
        case 500:
          console.error("Server error. Please try again later.");
          break;
        default:
          console.error(`Error: ${error.response.statusText}`);
      }
    } else {
      // If no response from the server (network error or timeout)
      console.error("Network error or timeout. Please check your connection.");
    }

    // Reject the error so components can handle it as well
    return Promise.reject(error);
  }
);

export { isMockEnabled };
export default api;
